<template>
  <span>{{ timeStr }}</span>
</template>

<script>
export default {
  data() {
    return {
      intervalId: null,
      timeStr: ''
    };
  },

  props: {
    endTime: {
      type: Number,
      required: true,
    }
  },

  mounted() {
    this.intervalId = setInterval(() => {
      this.timeStr = this.formattedTime();
    }, 1000);
    this.timeStr = this.formattedTime();
  },

  methods: {
    formattedTime() {
      if (this.endTime - Date.now() <= 0) {
        this.$emit('count-down-end');
        clearInterval(this.intervalId);
        return '00:00';
      }
      const remainingTime = this.endTime - Date.now();
      const minutes = Math.floor(remainingTime / (60 * 1000));
      const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>
